module.exports = __webpack_public_path__ + "static/media/let2.2743cbe6.JPG";